/* @ts-expect-error module is untyped */
import { cleanObject } from 'ecosystem-marketplace-core/utils/formatters';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import AssetCardResult from '../../common/records/AssetCardResult';
const defaults = {
  total: 0,
  items: []
};

function createJsonCopy(json) {
  const jsonCopy = Object.assign({}, json);

  if ('items' in json) {
    jsonCopy.items = json.items.map(item => new AssetCardResult(item));
  }

  return jsonCopy;
}

export default class ModuleSearchResponse extends createImmutableObjectClass(defaults, {
  fromJSON: (_ref) => {
    let rest = Object.assign({}, _ref);
    return cleanObject(createJsonCopy(Object.assign({}, rest)));
  },
  toJSON: (_ref2) => {
    let rest = Object.assign({}, _ref2);
    return Object.assign({}, rest);
  }
}) {}